module.exports = "<div class=\"dashboard\">\n  <div ng-if=\"showNews() && !config.maintenanceMessage\"\n    class=\"newsfeed-wrapper flex-child-grow flex-align-start flex-justify-center flex-column\"\n    ng-controller=\"NewsCtrl as News\" ng-require=\"'src/apps/news/views/desktop/home-feed.html'\">\n  </div>\n  <div ng-require=\"'src/apps/container/views/apps.html'\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/apps/container/views/dashboard1.html
// module id = 427
// module chunks = 22